import React, { Component } from "react";
import { ajaxManage } from "utils/common";
import Screen from "./screen";
import Table from "./table";

class App extends Component {
	state = {
		pageData: [],
		params: {
			pageNum: 1,
			pageSize: 10
		},
		pagination: {}
	}

	componentDidMount() {
		this.getData();
	}

	getData = () => {
		ajaxManage({
			url: "/account/getPageAccount",
			data: this.state.params
		}).then(res => {
			let pageAccount = res.data || {};
			this.setState({
				pageData: pageAccount.data || [],
				pagination: {
					current: pageAccount.pageNum,
					pageSize: pageAccount.pageSize,
					total: pageAccount.total
				}
			})
		}).catch(err => {
			this.props.history.replace("login");
		})
	}

	handleFormSubmit = (params) => {
		this.setState({
			params: {
				...this.state.params,
				...params,
				pageNum: 1
			}
		}, () => {
			this.getData();
		})
	}

	handleFormReset = () => {
		let { pagination } = this.state;
		this.setState({
			params: {
				pageNum: 1,
				pageSize: pagination.pageSize || 10
			}
		}, () => {
			this.getData();
		})
	}

	handleTableChange = (pagination) => {
		if(pagination.current === this.state.params.pageNum){
			return false;
		}
		this.setState({
			params: {
				...this.state.params,
				pageNum: pagination.current,
				pageSize: pagination.pageSize
			}
		}, () => {
			this.getData();
		})
	}

  	render() {
    	const { pageData, pagination } = this.state;

    	return (
    		<React.Fragment>
    			<div className="list-screen">
            		<div className="list-screen-header">
            			<span></span>
						<p>视频流水页</p>
            		</div>
            		<Screen
            			handleFormSubmit={this.handleFormSubmit}
            			handleFormReset={this.handleFormReset}
            		/>
            	</div>
        		<Table
        			pageData={pageData}
        			pagination={pagination}
        			handleTableChange={this.handleTableChange}
        		/>
    		</React.Fragment>
		);
	}
}

export default App;